import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosApiInstance from '../../../utils/axiosConfig';
import { ROOT, ORG } from '../../util/constants';

export const loadQuestionnaire = createAsyncThunk('onboarding/loadQuestionnaire', async () => {
    const questionnaireData = await axiosApiInstance.get(ROOT + `/onboard-doc?org=${ORG}`);
    return questionnaireData?.data;
});

export const uploadTraitStrengthMapping = createAsyncThunk(
    'onboarding/uploadTraitStrengthMapping', async ({ previousAnswers, questionnaire, pageIndex }) => {
    await axiosApiInstance.post(ROOT + `/trait-strengths?org=${ORG}`, { previousAnswers, questionnaire, pageIndex });
});